/**
 * Runtime/build env access.
 *
 * - REACT_APP_* : app config (CRA process.env + Docker window._env_)
 * - NODE_ENV    : build mode set by react-scripts (development | production | test)
 *               Do not put NODE_ENV in .env — CRA overwrites it.
 */

const APP_ENV_TO_FIREBASE_PREFIX = {
  LOCALHOST: "local",
  DEVELOPMENT: "dev",
  STAGING: "stage",
  PRODUCTION: "prod",
};

export function getEnv(key) {
  if (typeof window !== "undefined" && window._env_) {
    const runtimeValue = window._env_[key];
    if (runtimeValue !== undefined && runtimeValue !== "") {
      return runtimeValue;
    }
  }

  return process.env[key];
}

export function getEnvNumberList(key, fallback = []) {
  const raw = getEnv(key);

  if (!raw) return fallback;

  return raw
    .split(",")
    .map((id) => Number(id.trim()))
    .filter((id) => !Number.isNaN(id));
}

/** CRA / webpack build mode: development | production | test */
export function getNodeEnv() {
  return process.env.NODE_ENV || "development";
}

export function isNodeProduction() {
  return getNodeEnv() === "production";
}

export function isNodeDevelopment() {
  return getNodeEnv() === "development";
}

/** Deployment target from REACT_APP_ENV (LOCALHOST | DEVELOPMENT | STAGING | PRODUCTION) */
export function getAppEnv() {
  return String(getEnv("REACT_APP_ENV") || "")
    .trim()
    .toUpperCase();
}

export function isLocalhostApp() {
  return getAppEnv() === "LOCALHOST";
}

export function isProductionApp() {
  return getAppEnv() === "PRODUCTION";
}

/** Firebase RTDB path prefix derived from REACT_APP_ENV */
export function getFirebaseEnvPrefix() {
  return APP_ENV_TO_FIREBASE_PREFIX[getAppEnv()] ?? null;
}
